import mediaManagerTemplateDataMapper from 'modules/core/domain/data-mappers/media-manager-template-data-mapper';
import { MediaManagerTemplateGroupGql } from 'modules/manager/domain/graphql/media-manager-template-groups';
import { MediaManagerTemplateGroup } from 'modules/manager/domain/interfaces/media-manager-template-group';

const mediaManagerTemplateGroupDataMapper = (group: MediaManagerTemplateGroupGql): MediaManagerTemplateGroup => {
  return {
    id: group.id,
    name: group.name,
    tournamentId: group.tournamentId ?? null,
    templatesCount: group.templatesCount,
    templates: (group.templates ?? []).map(mediaManagerTemplateDataMapper),
    createdAt: group.createdAt,
    updatedAt: group.updatedAt,
  };
};

export default mediaManagerTemplateGroupDataMapper;
